import { useActiveConversation } from '../components/chat/ActiveConversationContext';
import type { ChatHandoff } from './chat-handoff';

// Open the side chat IN PLACE with a pre-filled, auto-sent message — without
// navigating away or stamping query params. The chat is always mounted
// (FloatingChat) and keys its open state off the shared ActiveConversation store,
// so opening it is a plain imperative call, the same shape as
// TaskSidePanel.openTask: point the store at the message, and the overlay expands
// and auto-sends. Returns a no-op for a blank message.
export function useOpenSideChat() {
  const { openChatWithMessage } = useActiveConversation();
  return (handoff: ChatHandoff) => {
    const message = handoff.message.trim();
    if (!message) return;
    openChatWithMessage({ ...handoff, message });
  };
}
